import React from 'react'
import { useTranslation } from 'react-i18next'
import LocalizedLink from '../LocalizedLink/LocalizedLink'
import Logo from '../../images/logo-2.svg'
import Services from '../../api/Services';



const Footer = (props) => {
    const { t } = useTranslation(['footer', 'navbar', 'services']);
    return (
        <footer className="site-footer">
            <div className={`upper-footer ${props.ftClass}`}>
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={Logo} alt="blog" />
                                </div>
                                <p>{t('footer:about')}</p>
                                <div className="social-widget">
                                    <ul>
                                        <li><a target='_blank'rel="noopener noreferrer" href="https://www.facebook.com/darMhamedAttaoui"><i className="ti-facebook"></i></a></li>
                                        <li><LocalizedLink to="/"><i className="ti-twitter-alt"></i></LocalizedLink></li>
                                        <li><LocalizedLink to="/"><i className="ti-linkedin"></i></LocalizedLink></li>
                                        <li><a href="https://www.instagram.com/dar.attaoui"><i className="ti-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title ">
                                    <h3>{t('footer:ourServices')}</h3>
                                </div>
                                <ul>
                                    {Services.slice(0, 6).map((service, Sitem) => (
                                        <li className='' key={Sitem}><LocalizedLink to={`/service-single/${service.slug}`}>{t(`services:${service.slug}.title`)}</LocalizedLink></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget s2">
                                <div className="widget-title ">
                                    <h3>{t('footer:quickLinks')}</h3>
                                </div>
                                <ul >
                                    <li className=''><LocalizedLink to="/home">{t('navbar:home')}</LocalizedLink></li>
                                    <li className=''><LocalizedLink to="/about">{t('navbar:about')}</LocalizedLink></li>
                                    <li className=''><LocalizedLink to="/service">{t('navbar:services')}</LocalizedLink></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            {/* <div className="widget newsletter-widget">
                                <div className="widget-title">
                                    <h3>Newsletter</h3>
                                </div>
                                <form onSubmit={SubmitHandler}>
                                    <input type="email" className="form-control" name="mail" id="mail"
                                        placeholder="Your Email..." />
                                    <input className="theme-btn" type="submit" value="Subscribe" />
                                </form>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="lower-footer">
                <div className="container">
                    <div className="row g-0">
                        <div className="col col-lg-6 col-12">
                            <p className="copyright">
                                {t('footer:copyright', { year: new Date().getFullYear() })}
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;